/**
 * ARTmosphere books shown on Create (Bookstore) page and used for upload tagging.
 * `uploadTag` is the value stored on artwork `tag` / book co-learning payloads (must match existing Firestore usage).
 */

export const createPageBooks = [
  {
    id: 'book1',
    title: 'Around the World - Part 1',
    uploadTag: 'Around the world with 100 artists',
    price: 499,
    color: 'bg-amber-100',
    image: '/assets/around-world-artists.png',
    description: 'Explore art from 25 countries through the eyes of incredible artists.',
    detailedDescription:
      'Journey through the rich tapestry of global art history with this comprehensive guide featuring 25 master artists. From ancient cave paintings to contemporary digital art, discover the techniques, stories, and cultural contexts that shaped artistic movements worldwide.',
    videoUrl: '/videos/around-world-artists-preview.mp4',
    duration: '2:34',
    ageRange: '8-16 years',
    pages: 120,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Interactive timelines', 'Cultural context', 'Technique tutorials', 'Artist biographies'],
  },
  {
    id: 'book1b',
    title: 'Around the World - Part 2',
    uploadTag: 'Around the world with 100 artists',
    price: 499,
    color: 'bg-amber-100',
    image: '/assets/around-world-artists.png',
    description: 'Continue your journey exploring art from 25 more countries.',
    detailedDescription:
      'Continue your global art adventure with 25 more master artists from different countries. Discover new techniques, stories, and cultural contexts that shaped artistic movements worldwide.',
    videoUrl: '/videos/around-world-artists-preview.mp4',
    duration: '2:34',
    ageRange: '8-16 years',
    pages: 120,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Interactive timelines', 'Cultural context', 'Technique tutorials', 'Artist biographies'],
  },
  {
    id: 'book1c',
    title: 'Around the World - Part 3',
    uploadTag: 'Around the world with 100 artists',
    price: 499,
    color: 'bg-amber-100',
    image: '/assets/around-world-artists.png',
    description: 'Explore art from 25 additional countries in this third installment.',
    detailedDescription:
      'Dive deeper into global art history with 25 more master artists. Learn about diverse techniques, stories, and cultural contexts from around the world.',
    videoUrl: '/videos/around-world-artists-preview.mp4',
    duration: '2:34',
    ageRange: '8-16 years',
    pages: 120,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Interactive timelines', 'Cultural context', 'Technique tutorials', 'Artist biographies'],
  },
  {
    id: 'book1d',
    title: 'Around the World - Part 4',
    uploadTag: 'Around the world with 100 artists',
    price: 499,
    color: 'bg-amber-100',
    image: '/assets/around-world-artists.png',
    description: 'Complete your journey with art from the final 25 countries.',
    detailedDescription:
      'Complete your global art exploration with the final 25 master artists. Experience the full diversity of artistic movements, techniques, and cultural contexts from around the world.',
    videoUrl: '/videos/around-world-artists-preview.mp4',
    duration: '2:34',
    ageRange: '8-16 years',
    pages: 120,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Interactive timelines', 'Cultural context', 'Technique tutorials', 'Artist biographies'],
  },
  {
    id: 'book2',
    title: "What's Your Story?",
    uploadTag: "What's your story",
    price: 399,
    color: 'bg-amber-100',
    image: 'https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=400&q=80',
    description: 'Create your own characters and adventures through guided art prompts.',
    detailedDescription:
      'Unleash your creativity with this interactive storytelling guide that combines art and narrative. Learn character design, world-building, and visual storytelling techniques while creating your own unique stories and illustrations.',
    videoUrl: '/videos/whats-your-story-preview.mp4',
    duration: '3:12',
    ageRange: '6-14 years',
    pages: 96,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Character creation', 'Story prompts', 'Illustration guides', 'Digital tools'],
  },
  {
    id: 'book3',
    title: 'Daily Acts of Art Part 1',
    uploadTag: 'Simple acts of art',
    price: 349,
    color: 'bg-amber-100',
    image: 'https://images.unsplash.com/photo-1587613865763-4ac3a4c3f351?auto=format&fit=crop&w=400&q=80',
    description: 'Simple 20-minute art activities to spark your creativity every day.',
    detailedDescription:
      'Engage in quick, fun, and simple 20-minute art activities designed to spark creativity. Perfect for daily practice, these activities help develop artistic skills while providing a relaxing and enjoyable creative outlet.',
    videoUrl: '/videos/complete-story-preview.mp4',
    duration: '2:45',
    ageRange: '7-15 years',
    pages: 80,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Quick activities', '20-minute sessions', 'Simple techniques', 'Daily practice'],
  },
  {
    id: 'book4',
    title: 'Impressionism',
    uploadTag: 'Impressionism',
    price: 449,
    color: 'bg-amber-100',
    image: 'https://images.unsplash.com/photo-1587502536263-9298c16bcdcf?auto=format&fit=crop&w=400&q=80',
    description: 'Paint like Monet and Renoir with brushstroke guides and color magic.',
    detailedDescription:
      'Master the techniques of the Impressionist masters with this comprehensive guide to light, color, and brushwork. Learn to capture the fleeting effects of light and atmosphere in your own digital paintings.',
    videoUrl: '/videos/impressionism-preview.mp4',
    duration: '4:18',
    ageRange: '10-18 years',
    pages: 140,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Brush technique', 'Color theory', 'Light studies', 'Master recreations'],
  },
  {
    id: 'book5',
    title: 'Pointillism',
    uploadTag: 'Pointillism',
    price: 349,
    color: 'bg-amber-100',
    image: 'https://images.unsplash.com/photo-1585841691528-2d8e4e1e1ff9?auto=format&fit=crop&w=400&q=80',
    description: 'Dot your way to brilliance using tips from pointillist masters!',
    detailedDescription:
      'Discover the fascinating world of pointillism through interactive exercises and digital tools. Learn how tiny dots can create stunning visual effects and master this unique painting technique.',
    videoUrl: '/videos/pointillism-preview.mp4',
    duration: '3:28',
    ageRange: '9-16 years',
    pages: 88,
    format: 'Digital Interactive',
    language: 'English',
    features: ['Dot techniques', 'Color mixing', 'Pattern creation', 'Digital tools'],
  },
];

/** Distinct upload tag strings for book co-learning pipeline (Create page books + legacy tag still used in app). */
export const BOOK_CO_LEARNING_UPLOAD_TAGS = [
  ...Array.from(new Set(createPageBooks.map((b) => b.uploadTag))),
  'Complete the story',
];
